import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { useStatement } from '../../hooks';
import { Statement } from '../../dtos';
import theme from '../../theme';
import { ImageHandler } from '../../components';
import { MainLayout } from '../../components/layouts';
import { VoucherIcon } from '../../components/icons';
import {
    Container,
    Header,
    ExhibitorHeader,
    AmountHeader,
    Content,
    Recipients,
    NoData
} from './styles';

const StatementPage: React.FC = () => {
    const navigate = useNavigate();
    const { statements } = useStatement();

    const getTotalAmountDistributed = useCallback((statement: Statement) =>
        statement.recipients.reduce<number>((amount, recipient) => amount + recipient.amount, 0), []);

    return (
        <MainLayout id="statement" title="Extrato de distribuição">
            {statements.length > 0 ? (
                <Container>
                    <ul>
                        {statements.map((statement, index) => (
                            <li
                                id={`statement.distributions${index}.box`}
                                key={index}
                                onClick={() => {
                                    navigate('/distribution/detail', {
                                        state: {
                                            statement
                                        }
                                    });
                                }}>
                                <span>{format(statement.date, 'dd/MM/yyyy HH:mm')}</span>
                                <Content>
                                    <Header>
                                        <ExhibitorHeader>
                                            <ImageHandler
                                                url={statement.exhibitor.logo}
                                                alt={statement.exhibitor.name}
                                            />
                                            <div>
                                                <strong>{statement.exhibitor.name}</strong>
                                                <small>{statement.voucherType.name}</small>
                                            </div>
                                        </ExhibitorHeader>
                                        <AmountHeader>
                                            <span><VoucherIcon iconColor={theme.primaryColor} /></span>
                                            <span>{getTotalAmountDistributed(statement)}</span>
                                        </AmountHeader>
                                    </Header>
                                    <Recipients>
                                        {statement.recipients.map(recipient => (
                                            <li key={recipient.email}>
                                                <div>
                                                    <small>{recipient.email}</small>
                                                    <small>{recipient.name}</small>
                                                    <small>{recipient.phoneNumber}</small>
                                                </div>
                                                <span>{recipient.amount}</span>
                                            </li>
                                        ))}
                                    </Recipients>
                                </Content>
                            </li>
                        ))}
                    </ul>
                </Container>
            ) : (
                <NoData>Nenhuma distribuição realizada!</NoData>
            )}
        </MainLayout>
    );
};

export { StatementPage };
